import { InstructionModal } from './InstructionModal';

export default InstructionModal;
